import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupTwo = () => {
  const { t } = useTranslation();
  return {
    birth_spacing_parity: Yup.string()
      .required(
        t("validation.required", {
          birth_spacing_parity: t("page.birth_spacing_parity"),
        })
    ),
    birth_spacing_occasion: Yup.string()
      .required(
        t("validation.required", {
          birth_spacing_occasion: t("page.birth_spacing_occasion"),
        })
    ),
    
    
  };
};
 